import * as React from 'react'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'
import { CategoryGroupBy, typeToDisplay } from './GroupByHelper'

export const ArtistChart: React.FunctionComponent = (props) => {

    const [type, setType] = React.useState<string>()
    const toolbarItems = CategoryGroupBy({ onTypeChange: setType })
    if (!type) {
        return null
    }

    return (
        <BPMChart {...props} title='Number of Artists' subTitle={'By ' + typeToDisplay(type)} type='pie'
            onRequestLoad={(options, signal) => {
                return BPMAnalyticsAPI.get<any>('categories/byCol', options, signal)
            }} additionalParams={{ type: 'artist', groupBy: type }} toolBarItems={() => toolbarItems}
            allowedTypes={['spline', 'bar', 'doughnut', 'pie', 'tree']}
            series={{
                name: 'Number of Artists',
                valueField: 'count',
                argumentField: type,
                smallValuesGrouping: { topCount: 20, mode: 'topN' }
            }}>
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Category/charts/ArtistChart.tsx